import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,  
  state: {},
  actions: {
    addProducto (context, producto) {
      return new Promise((resolve, reject) => {
        axios.post('/api/productos', producto)
          .then((response) => {                            
            resolve(response)
          })
          .catch((error) => {
            reject(error) 
          })
      })
    },
    deleteProducto (context, id) {
      return new Promise((resolve, reject) => {        
        axios.delete(`/api/productos/${id}`)
          .then((response) => {                            
            resolve(response)
          })
          .catch((error) => {
            reject(error) 
          })
      })
    },
    updateProductoTarjetas (context, detalle) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/producto_tarjetas/${detalle.id}`, detalle, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {            
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    }
  },
  mutations: {},
  modules: {}
})